var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.stateLoading)?_c('v-skeleton-loader',{attrs:{"type":_vm.type,"min-width":'80px'}}):_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }